import Swiper from 'swiper';

class SliderHomepage {
  component;
  trigger;
  constructor() {
    this.component = document.querySelectorAll(
      '[data-component="slider-homepage"]'
    );
    this.trigger = document.querySelectorAll(
      '[data-trigger="slider-homepage"]'
    );
    if (this.component && this.trigger) {
      this._init();
    }
  }
  _init() {
    this.trigger.forEach((element) => {
      let mySwiper: any = null;

      const firstImage = element.querySelector('img');
      if (firstImage) {
        firstImage.onload = () => {
          if (mySwiper) {
            mySwiper.update();
          }
        };
      }

      mySwiper = new Swiper(element, {
        spaceBetween: 15,
        preventClicks: true,
        watchOverflow: true,
        slidesPerView: 1,
        freeMode: true,
        allowTouchMove: false,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    });
  }
}
export const sliderHomepage = new SliderHomepage();
